import { Typography } from '@ywwwtseng/tma-react-kit';
import { Operation } from '@/components/common/Operation';
import { BalanceTokenList } from '@/components/common/BalanceTokenList';
import { useUserBalanceTotal } from '@/hooks/useUserBalanceTotal';
import { useTokens } from '@/hooks/useTokens';

export default function BalanceScreen() {
  const tokens = useTokens();
  const { formatted } = useUserBalanceTotal();

  return (
    <div className="flex flex-col items-center justify-start w-full gap-5 py-3 px-5">
      <div className="flex items-end w-full gap-2 !justify-start">
        <Typography size="7" weight={600}>
          ${formatted}
        </Typography>
        <Typography className="pb-1" size="1" weight={500}>
          USDT
        </Typography>
      </div>
      <Operation />
      <div className="v-stack w-full gap-2 !items-start">
        <Typography size="4" weight={600} i18n="common.tokens" />
        <BalanceTokenList tokens={tokens} />
      </div>
    </div>
  );
}
